import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import { RepoNamePicker } from './RepoNamePicker';
import { ImagePreviewField } from './ImagePreviewField';
import { EmployeePicker } from './EmployeePicker';
import { EnvironmentServerPicker } from './EnvironmentServerPicker';
import { DevopsEnvironmentPicker } from './DevopsEnvironmentPicker';
import { ResponsibleTeamPicker } from './ResponsibleTeamPicker';
import { ConfiguredGithubOwner } from './ConfiguredGithubOwner';
import { SystemPicker } from './SystemPicker';

export const responsibleTeamPickerFormField = FormFieldBlueprint.make({
  name: 'responsible-team-picker',
  params: { field: async () => ResponsibleTeamPicker },
});

export const repoNamePickerFormField = FormFieldBlueprint.make({
  name: 'repo-name-picker',
  params: {
    field: async () => RepoNamePicker,
  },
});

export const imagePreviewFormField = FormFieldBlueprint.make({
  name: 'image-preview-field',
  params: {
    field: async () => ImagePreviewField,
  },
});

export const employeePickerFormField = FormFieldBlueprint.make({
  name: 'employee-picker',
  params: {
    field: async () => EmployeePicker,
  },
});

export const environmentServerPickerFormField = FormFieldBlueprint.make({
  name: 'environment-server-picker',
  params: {
    field: async () => EnvironmentServerPicker,
  },
});

export const devopsEnvironmentPickerFormField = FormFieldBlueprint.make({
  name: 'devops-environment-picker',
  params: {
    field: async () => DevopsEnvironmentPicker,
  },
});

export const provisioningModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    FormFieldBlueprint.make({
      name: 'system-picker',
      params: { field: async () => SystemPicker },
    }),
    FormFieldBlueprint.make({
      name: 'configured-github-owner',
      params: { field: async () => ConfiguredGithubOwner },
    }),
    repoNamePickerFormField,
    imagePreviewFormField,
    employeePickerFormField,
    environmentServerPickerFormField,
    devopsEnvironmentPickerFormField,
    responsibleTeamPickerFormField,
  ],
});

export default provisioningModule;
